// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { columnsStyles } from "@cahaba/Overrides/Widgets/ProductList/ProductListColumns";
import { css } from "styled-components";

columnsStyles.container = {
    gap: 15,
    css: css`
        margin-bottom: 30px;
    `,
};

columnsStyles.leftColumnGridItem = {
    width: [12, 12, 4, 3, 3],
    css: css`
        padding: 0 20px 0 0;
        flex-wrap: wrap;
        align-items: flex-start;
        flex-direction: column;
        @media (max-width: 768px) {
            padding: 0 10px;
        }
    `,
};

columnsStyles.rightColumnGridItem = {
    width: [12, 12, 8, 9, 9],
    css: css`
        padding-top: 0;
        padding-bottom: 0;
    `,
};

columnsStyles.filterWidgetWrapper = {
    css: css`
        width: 100%;
        border: 1px solid #b5b5b5;
        height: auto;
        padding: 0;
        flex-wrap: wrap;
        align-items: flex-start;
        flex-direction: column;
        @media (max-width: 768px) {
            margin-bottom: 20px;
        }
    `,
};
